import { render, staticRenderFns } from "./InvoiceInfo.vue?vue&type=template&id=33b6a2e6&scoped=true&"
import script from "./InvoiceInfo.vue?vue&type=script&lang=ts&"
export * from "./InvoiceInfo.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceInfo.vue?vue&type=style&index=0&id=33b6a2e6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b6a2e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/intern/customer-portal/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import GCardIcon from 'shared/global/components/CardIcon.vue'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
installComponents(component, {GCardIcon,VCard,VCardTitle,VDataTable,VDivider})
